import mitt from 'mitt';

export enum EventsName {
  PAYMENT_METHOD_CHANGED = 'payment_method_changed',
}

type Events = {
  [EventsName.PAYMENT_METHOD_CHANGED]: undefined;
};

const eventEmitter = mitt<Events>();

export default eventEmitter;
